import { GetCommentRequest } from '~/types';
import { GetGameCommentListRequest } from '~/types/missionGameApi';

const commentKey = {
  all: ['comment'] as const,
  getCommentList: ({ character_id, sort_by }: GetCommentRequest) =>
    [...commentKey.all, 'list', character_id, sort_by] as const,
  getGameCommentList: ({ game_id, sort_by }: GetGameCommentListRequest) =>
    [...commentKey.all, 'list_game', game_id, sort_by] as const,
} as const;

export default commentKey;
